import { Link } from 'react-router-dom'
import maharajPortrait from '../../../assets/images/maharaj-ji.png'

const MANDALA_DOTS = [
  { cx: 100, cy: 10 },
  { cx: 184, cy: 70 },
  { cx: 16, cy: 130 },
  { cx: 150, cy: 168 },
  { cx: 50, cy: 32 },
  { cx: 186, cy: 118 },
  { cx: 14, cy: 82 },
]

export default function MaharajBookingHeroSection() {
  return (
    <div className="relative overflow-hidden bg-primary text-white pt-28 pb-16">
      <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-b from-[#3a0a14] via-primary to-[#2a0710]" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(55%_70%_at_50%_0%,rgba(232,119,15,0.20),transparent_70%)]" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(45%_55%_at_100%_100%,rgba(232,119,15,0.10),transparent_70%)]" />

      <div
        aria-hidden="true"
        className="absolute right-[-4rem] top-1/2 -translate-y-1/2 w-[24rem] h-[24rem] opacity-[0.10] animate-[spin_140s_linear_infinite] motion-reduce:animate-none flex items-center justify-center pointer-events-none"
      >
        <span className="text-[170px] text-[#E6C878] select-none">ॐ</span>
      </div>
      <svg
        aria-hidden="true"
        className="absolute right-[-2rem] top-1/2 -translate-y-1/2 w-[28rem] h-[28rem] opacity-[0.14] animate-[spin_260s_linear_infinite_reverse] motion-reduce:animate-none pointer-events-none"
        viewBox="0 0 200 200"
        fill="none"
        stroke="#E6C878"
      >
        <circle cx="100" cy="100" r="94" strokeWidth="0.4" />
        <circle cx="100" cy="100" r="10" strokeWidth="0.8" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(60 100 100)" />
        <ellipse cx="100" cy="100" rx="90" ry="44" strokeWidth="0.5" transform="rotate(120 100 100)" />
        {MANDALA_DOTS.map((dot) => (
          <circle key={`${dot.cx}-${dot.cy}`} cx={dot.cx} cy={dot.cy} r="2.4" fill="#E6C878" stroke="none" fillOpacity="0.7" />
        ))}
      </svg>

      <div className="container px-6 mx-auto relative z-10">
        <div className="flex flex-wrap items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-white/40 mb-7">
          <Link to="/" className="hover:text-secondary transition-colors">Home</Link>
          <span className="opacity-40">/</span>
          <Link to="/maharaj-ji" className="text-white/60 hover:text-secondary transition-colors">Astro Raju Maharaj Ji</Link>
          <span className="opacity-40">/</span>
          <span className="text-secondary">Book</span>
        </div>

        <div className="flex flex-wrap items-end justify-between gap-8">
          <div className="max-w-xl">
            <div className="flex flex-wrap items-center gap-2 mb-5">
              <div className="hero-chip inline-flex">
                <span className="text-secondary">✦</span> Premium Consultation
              </div>
              <div className="hero-card-badge">
                <svg className="w-3 h-3 text-secondary" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M5 16 3 6l5.5 4L12 4l3.5 6L21 6l-2 10H5Zm0 2h14v2H5v-2Z" />
                </svg>
                By Invitation
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-cinzel leading-tight">
              Book Your Audience with the <span className="text-gradient-gold">Maharaj</span>
            </h1>
            <p className="text-white/50 text-sm mt-3">Choose a date — your priority tier and fee are set automatically.</p>

            <div className="flex flex-wrap items-center gap-6 mt-7 pt-6 border-t border-white/10">
              <div>
                <p className="text-2xl font-cinzel text-secondary leading-none">4,800+</p>
                <p className="text-[9px] uppercase tracking-widest text-white/40 mt-1.5">Verified Clients</p>
              </div>
              <div className="w-px h-8 bg-white/10" />
              <div>
                <p className="text-2xl font-cinzel text-secondary leading-none">98%</p>
                <p className="text-[9px] uppercase tracking-widest text-white/40 mt-1.5">Success Rate</p>
              </div>
              <div className="w-px h-8 bg-white/10" />
              <div>
                <p className="text-2xl font-cinzel text-secondary leading-none">15+</p>
                <p className="text-[9px] uppercase tracking-widest text-white/40 mt-1.5">Years Mastery</p>
              </div>
            </div>
          </div>

          <div className="hero-card-glass flex items-center gap-3 rounded-2xl px-4 py-3">
            <div className="relative shrink-0">
              <img
                src={maharajPortrait}
                alt="Raju Maharaj Ji"
                className="w-12 h-12 rounded-full object-cover border-2 border-secondary/40"
              />
              <span className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-emerald-500 border-2 border-white flex items-center justify-center">
                <svg className="w-2 h-2 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m5 13 4 4L19 7" />
                </svg>
              </span>
            </div>
            <div className="text-left">
              <p className="text-sm font-semibold text-[#1C140A] leading-tight">Raju Maharaj Ji</p>
              <p className="text-[10px] text-[#5C3A18] mt-0.5">15+ Yrs · Vedic Astrology Master</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
